import React, { useEffect } from "react";
import Blogs from "../components/blog/Blogs";
import { BsStackOverflow } from "react-icons/bs";
import { FaDev } from "react-icons/fa";
import { SiMedium } from "react-icons/si";
import { useLocation } from "react-router-dom";


const BlogsPage = () => {

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div>
      <section className="pt-5 pb-10 lg:pt-10 lg:pb-10">
        <div className="container mx-auto">
          <div className="-mx-4 flex flex-wrap justify-center md:mb-5">
            <div className="w-full px-4">
              <div className="grid grid-cols-10 pb-5 mb-5 gap-3">
                <div className="lg:col-span-5 col-span-10 px-4">
                  <span className="text-primary mb-2 block text-lg font-bold font-inter">
                    Latest Blogs
                  </span>
                  <h2 className="text-dark mb-4 text-2xl font-bold font-poppins sm:text-4xl md:text-[40px]">
                    Recent Blog Articles
                  </h2>
                  <p className="font-inter text-gray-500 font- text-base">
                    There are many variations of passages of Lorem Ipsum
                    available <br className="hidden sm:block" /> but the
                    majority have suffered alteration in some form.
                  </p>
                </div>
                <div className="lg:col-span-5 col-span-10 px-4 flex justify-center items-center">
                  <div className="overflow-x-hidden container-snap border-b">

                    <a
                      href="https://mahbub1.medium.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="p-2 m-2 bg-white border rounded-full shadow-lg">
                        <SiMedium className="text-xl" />
                      </button>
                    </a>
                    <a
                      href="https://dev.to/mahbubdev1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="p-2 m-2 bg-white border rounded-full shadow-lg">
                        <FaDev className="text-xl" />
                      </button>
                    </a>
                    <a
                      href="https://stackoverflow.com/users/21193104/munir-uddin-mahbub"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="p-2 m-2 bg-white border rounded-full shadow-lg">
                        <BsStackOverflow className="text-xl text-[#F27009]" />
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Blogs />
        </div>
      </section>
    </div>
  );
};

export default BlogsPage;
